<template>
  <div>
    <HeaderReceipt header="ดูรายละเอียดใบเสร็จ" :img_header="header_image" link_back="stock/storage/addproducttostock"/>
    <StoragePR_detail/>
  </div>
</template>

<script>
import StoragePR_detail from "@/components/admin/stock/pr/StoragePR_detail";
import HeaderReceipt from "@/components/admin/stock/menustorage/HeaderReceipt";
import HeaderImage from "@/assets/verified.png";
export default {
  name: "PrDetail",
  data() {
    return {
      header_image: HeaderImage
    }
  },
  components: {
    HeaderReceipt,
    StoragePR_detail
  }
}
</script>

<style scoped>

</style>
